export type GlobImport = Record<string, { default: string }>

export function resolveAsset (glob: GlobImport, filename: string): string {
  const entry = Object.entries(glob).find(([path]) => path.endsWith(filename))
  return entry?.[1].default ?? ''
}

/**
 * Resolves a carousel image path with locale support.
 * @param glob - The glob import containing all image assets
 * @param locale - The current locale (e.g., 'en', 'it')
 * @param path - The locale-agnostic path (e.g., 'red/red_c1_s1.jpg')
 * @returns The resolved asset URL
 */
export function resolveCarouselAsset (glob: GlobImport, locale: string, path: string): string {
  const fullPath = `/carousel/${locale}/${path}`
  return resolveAsset(glob, fullPath)
}
